export default "__VITE_ASSET__DEZKfRt4__"